import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import { connect } from 'react-redux';
import * as LoginService from '../../Services/Login/LoginService';
import { thunk_reset_user, thunk_set_user } from '../../Action/action';
import toast, { Toaster } from 'react-hot-toast';
import { Download, Eye, EyeOff, Smartphone, X } from 'lucide-react';
import LoadingSpinnerComponent from "../Loader/LoadingSpinnerComponent";
import ForgotPasswordComponent from "./ForgotPasswordComponent";
import "./LoginComponent.css"
import { SiAppstore, SiGoogleplay } from 'react-icons/si';
import googlePlay from "../../Images/google-play.png"
import playStore from "../../Images/app-store.png"
import playStoreQr from "../../Images/play-store-qr.png"
import appStoreQr from "../../Images/app-store-pp-qr.png"

function LoginComponent(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isOtp, setIsOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [canResend, setCanResend] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [qrModal, setQrModal] = useState(false)
  const [appQrModal, setAppQrModal] = useState(false)

  const { reset } = useForm();

  // Countdown timer effect
  useEffect(() => {
    let interval = null;
    if (isOtp && countdown > 0 && !canResend) {
      interval = setInterval(() => {
        setCountdown(countdown => countdown - 1);         //Decrement countdown
      }, 1000);
    } else if (countdown === 0) {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [isOtp, countdown, canResend]);

  const startCountdown = () => {
    setCountdown(60);
    setCanResend(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const req_data = {
      emailId: btoa(email),
      password: btoa(password)
    };
    //debugger;
    if (isOtp) {
      req_data.otp = otp
      LoginService.ValidateUserOtp(req_data)
        .then(({ data }) => {
          //debugger;
          if (data.IsSuccess) {
            setIsOtp(data.Data.User.IsOtp)
            toast.success("Login Success");
            props.dispatch(thunk_reset_user([]));
            props.dispatch(thunk_set_user(data));
            //console.log('props', props);
            navigate('/dashboard');
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong."))
        .finally(() => { setLoading(false) });
    }
    else {

      LoginService.ValidateUser(req_data)
        .then(({ data }) => {
          //debugger;
          if (data.IsSuccess) {
            setIsOtp(data.Data.User.IsOtp)
            if (data.Data.User.IsOtp) {
              startCountdown();
              toast.success(data.ResponseMessage);
            }
            else {
              toast.success("Login Success");
              props.dispatch(thunk_reset_user([]));
              props.dispatch(thunk_set_user(data));
              //console.log('props', props);
              navigate('/dashboard');
            }
          } else {
            toast.error(data.ResponseMessage);
          }
        })
        .catch(() => toast.error("Something went wrong."))
        .finally(() => { setLoading(false) });
    }
  };

  const handleResendOtp = () => {
    setLoading(true);

    const req_data = {
      emailId: btoa(email),
      password: btoa(password)
    };

    LoginService.ValidateUser(req_data)
      .then(({ data }) => {
        //debugger;
        if (data.IsSuccess) {
          // setIsOtp(data.Data.User.IsOtp)
          if (data.Data.User.IsOtp) {
            startCountdown();
            toast.success(data.ResponseMessage);
          }
        } else {
          toast.error(data.ResponseMessage);
        }
      })
      .catch(() => toast.error("Something went wrong."))
      .finally(() => { setLoading(false) });
  }

  const handleForgotPassword = () => {
    setForgotPasswordModal(true)
  }

  const handleModalClose = () => {
    reset();
    setForgotPasswordModal(false)
  }

  return (
    <div
      className="container-fluid position-relative login-component"
      style={{
        //  background: "linear-gradient(to bottom right, rgba(144, 238, 144, 0.5), transparent)" 
        // backgroundColor: "#12994a",
      }}
    >
      <Toaster position="top-center" reverseOrder={false} />
      {loading && <LoadingSpinnerComponent className="login-spinner" />}

      {/*       
        <div className="col-md-6 d-flex flex-column justify-content-start align-items-start text-white text-start ps-5">
        <div className="w-100 d-flex justify-content-start align-items-start">
        <img
        src={require('../../Images/notch-login-logo.png')}
        alt="Notch Logo"
        style={{ width: "100px", marginBottom: "20px" }}
        />
        </div>
        
        <h2 className="fw-bold" style={{ maxWidth: "500px", color: "#fff" }}>
        Reliable diagnostics rooted in empathy
        </h2>
        
        <img
        src={require('../../Images/login-side-hand.png')}
        alt="Hand Heart"
        className="img-fluid mt-4"
        style={{ maxWidth: "450px", height: "auto" }}
        />
        </div> */}

      <header className="d-flex align-items-center justify-content-between w-100">
        <img
          src={require('../../Images/login-logo30.png')}
          alt="Metropolis Logo"
          className="header-image-one"
        />
        <img
          src={require('../../Images/notch-login-logo.png')}
          alt="Metropolis Logo"
          className="header-image-two"
        />
      </header>

      <section className="d-flex flex-column flex-lg-row justify-content-between align-items-center w-100 position-relative">

        {/* Form Starts Here */}
        <div className="order-lg-1">
          <div className="login-card shadow-lg">
            <div className="pb-3" style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
              <img
                src={require('../../Images/metropolis-logo.png')}
                className="metropolis-logo"
                alt="Metropolis Logo"
              />
            </div>

            <div className="pt-2">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-bold fs-6">Email</label>
                  <input
                    type="text"
                    disabled={isOtp}
                    className="form-control"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>

                <div className="mb-2" style={{ position: "relative" }}>
                  <label className="form-label fw-bold fs-6">Password</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    disabled={isOtp}
                    className="form-control"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{ paddingRight: "40px" }}
                  />
                  <button
                    type="button"
                    className="btn btn-sm position-absolute top-50 end-0 me-1"
                    tabIndex={-1}
                    style={{ background: "transparent", border: "none" }}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                  </button>
                </div>
                {isOtp == false && (
                  <a
                    style={{ float: "right", }}
                    href="#"
                    rel="noopener noreferrer"
                    className="text-decoration-underline text-muted mb-2 d-block"
                    tabIndex={-1}
                    onClick={(e) => {
                      e.preventDefault();
                      handleForgotPassword();
                    }}
                  >
                    <small>Forgot Password?</small>
                  </a>
                )}

                {isOtp && (
                  <div className="mb-2">
                    {/* <div className="alert alert-info py-2 mb-2" style={{ fontSize: '14px' }}>
                      <i className="bi bi-info-circle me-2"></i>
                      OTP has been sent to your registered email
                    </div> */}
                    <label className="form-label fw-bold fs-6">Enter OTP</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter OTP"
                      pattern="[0-9]*"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/[^0-9]/g, '');
                      }}
                      required
                    />
                    <div className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">Didn't receive OTP?</small>
                      {canResend ? (
                        <button
                          type="button"
                          className="btn btn-link btn-sm p-0 text-decoration-underline"
                          onClick={() => { handleResendOtp() }}
                          disabled={loading}
                        >
                          Resend OTP
                        </button>
                      ) : (
                        <small className="text-muted">Resend in {countdown}s</small>
                      )}
                    </div>
                  </div>
                )}

                <button type="submit" disabled={loading} className="btn custom-sumbitbtn w-100">Login</button>
              </form>
            </div>
          </div>
        </div>
        {/* Form Ends Here */}

        {/* Hand Image */}
        <div className="hand-logo-wrapper">
          <p className="hand-logo-text">Reliable diagnostics rooted in empathy</p>
          <img
            src={require('../../Images/login-side-hand.png')}
            alt="Metropolis Logo"
            style={{ width: "100%", height: "100%" }}
            className="hand-logo"
          />
        </div>

        {/* White Line */}
      </section>
      <div className="white-line"></div>

      {forgotPasswordModal && (
        <ForgotPasswordComponent handleModalClose={handleModalClose} />

      )}

      <footer className="d-flex gap-3 flex-column flex-md-row align-items-center justify-content-center justify-content-between">
        <div>
          <p>
            {/* Powered by Metropolis Healthcare Limited (We are also available on Mobile App{' '} */}
            Powered by Metropolis Healthcare Limited {/*(We are also available on Mobile App{' '}
            <a
              title="Download Metropolis Partner App"
              href="https://play.google.com/store/apps/details?id=com.metropolis.partnerportal"
              target="_blank"
              rel="noopener noreferrer"
              className="blink-icon"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <SiGoogleplay />
            </a>
            ) */}
          </p>
        </div>

        <div float="right" className="d-flex gap-3">

          <div className="playstore-btn-wrapper" style={{}}>
            <button onClick={() => setAppQrModal(true)} className="playstore-btn">
              <img src={playStore} alt="App Store Logo" style={{borderRadius:"5px"}} className="playstore-btn-logo" />
            </button>
          </div>


          <div className="playstore-btn-wrapper">
            <button onClick={() => setQrModal(true)} className="playstore-btn">
              <img src={googlePlay} alt="Play Store Logo" className="playstore-btn-logo" />
            </button>
          </div>

        </div>
      </footer>



      {appQrModal && (
        <div className="modal fade show d-block qr-modal-backdrop" tabIndex="-1" role="dialog" aria-labelledby="qrModalLabel" aria-hidden="false">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content qr-modal-content border-0 shadow-lg">
              {/* Modal Header */}
              <div className="modal-header qr-modal-header border-0">
                <h5 className="modal-title fw-bold text-white d-flex align-items-center" id="qrModalLabel">
                  <Smartphone className="me-2" size={24} />
                  Download IPhone App
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={() => setAppQrModal(false)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body qr-modal-body text-center px-4 py-4">
                <div className="mb-3">
                  <p className="text-muted mb-4 fs-6">
                    Scan the QR code or click the button below to download our IPhone App
                  </p>
                </div>

                {/* QR Code Container */}
                <div className="qr-code-container mx-auto mb-4">
                  <div className="qr-code-frame">
                    <img
                      src={appStoreQr}
                      alt="Play Store QR Code"
                      className="qr-code-image img-fluid"
                    />
                  </div>
                </div>

                <div className="d-grid gap-2">
                  <a
                    href="https://apps.apple.com/in/app/metropolis-partner-connect/id6754966807"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn custom-sumbitbtn btn-lg d-flex align-items-center justify-content-center"
                  >
                    <SiAppstore className="me-2" size={20} />
                    Open in App Store
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {qrModal && (
        <div className="modal fade show d-block qr-modal-backdrop" tabIndex="-1" role="dialog" aria-labelledby="qrModalLabel" aria-hidden="false">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content qr-modal-content border-0 shadow-lg">
              {/* Modal Header */}
              <div className="modal-header qr-modal-header border-0">
                <h5 className="modal-title fw-bold text-white d-flex align-items-center" id="qrModalLabel">
                  <Smartphone className="me-2" size={24} />
                  Download Mobile App
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  aria-label="Close"
                  onClick={() => setQrModal(false)}
                ></button>
              </div>

              {/* Modal Body */}
              <div className="modal-body qr-modal-body text-center px-4 py-4">
                <div className="mb-3">
                  <p className="text-muted mb-4 fs-6">
                    Scan the QR code or click the button below to download our Mobile App
                  </p>
                </div>

                {/* QR Code Container */}
                <div className="qr-code-container mx-auto mb-4">
                  <div className="qr-code-frame">
                    <img
                      src={playStoreQr}
                      alt="Play Store QR Code"
                      className="qr-code-image img-fluid"
                    />
                  </div>
                </div>

                <div className="d-grid gap-2">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.metropolis.partnerportal"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn custom-sumbitbtn btn-lg d-flex align-items-center justify-content-center"
                  >
                    <SiGoogleplay className="me-2" size={20} />
                    Open in Play Store
                  </a>

                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* <div className="position-absolute bottom-0 start-0 w-100 text-center">
        <hr style={{ borderTop: "3px solid white", margin: "0",color:"red"  }} />
        <p className="text-white fw-bold m-0 py-2" style={{ fontSize: "14px"}}>
          Powered by ABI-Health Technologies Private Limited
        </p>
      </div> */}
    </div >
  );
}

const mapStateToProps = (state) => ({ data: state });
export default connect(mapStateToProps)(LoginComponent);
